var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"client-bde52cb3": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"vendors-node_modules_xo-union_tk-component-fields_lib_components_AsyncTypeahead_styles_css-no-95453a":1,"apps_marketplace-web_client_components_shared_SearchWidget_Typeaheads_CategoryLocationTypeahe-2d37f2":1,"state":1,"apps_marketplace-web_client_components_unified-lightbox_Lightbox_tsx-apps_marketplace-web_cli-6200d9":1,"node_modules_xo-union_component-blank-button_lib_css_styles_css-node_modules_xo-union_tk-comp-a58526":1,"storefront-59ac198a":1,"storefront-f18498dd":1,"storefront-bde52cb3":1,"vendors-node_modules_xo-union_component-partial-star_lib_css_styles_css-node_modules_xo-union-2b937e":1,"photos":1,"booking":1,"booking-success":1,"city-bde52cb3":1,"category":1,"marketplace-home":1,"vendors-node_modules_xo-union_tk-component-vendor-card_lib_components_Stars_index_js-node_mod-d3f1cd":1,"review-wedding-vendors":1,"best-of-weddings":1,"node_modules_xo-union_tk-component-fields_lib_components_Option_styles_css-node_modules_xo-un-e8ca80":1,"ai-usage-policy":1,"legal-ai":1,"tkComponentDatepicker":1,"vendors-node_modules_xo-union_tk-component-badges_lib_components_StatusBadge_styles_css-node_-68b414":1,"vrm":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr